import React from 'react';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-heading font-bold text-slate-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing and using Lawfullingo, you agree to be bound by these Terms of Service and all applicable laws and regulations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">2. Use License</h2>
            <p className="text-slate-600 mb-4">
              Permission is granted to access the materials (information or software) on Lawfullingo's website for personal, non-commercial transitory viewing only.
            </p>
            <ul className="list-disc pl-5 text-slate-600 space-y-2">
              <li>You may not modify or copy the materials.</li>
              <li>You may not use the materials for any commercial purpose.</li>
              <li>You may not attempt to decompile or reverse engineer any software contained on the website.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">3. User Accounts</h2>
            <p className="text-slate-600 mb-4">
              You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Course Enrollment and Refunds</h2>
            <p className="text-slate-600 mb-4">
              Course enrollments are subject to our refund policy. Please review specific course details for information regarding access duration and refund eligibility.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;